import PropTypes from 'prop-types';
var propTypes = {
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  defaultOn: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  on: PropTypes.bool,
  onChange: PropTypes.func
};
export default propTypes;